import React from 'react';
import type { NodeToRenderProps } from '@src/components/custom-nodes/types';

interface FixedWidthHocProps {
  width: number;
  height: number;
}

export const withFixedSize = (WrappedComponent: React.FC<NodeToRenderProps>, { width, height }: FixedWidthHocProps ) => {
  return function FixedWidthWrapper(props: NodeToRenderProps) {
    return (
      <WrappedComponent
        {...props}
        style={{
          minWidth: `${width}px`,
          maxWidth: `${width}px`,
          minHeight: `${height}px`,
          maxHeight: `${height}px`
        }}
        >
        {props.children}
      </WrappedComponent>
    );
  };
}
